import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PeriodoContratoComponent } from "@views/periodos-contrato/periodos-contrato/periodo-contrato.component";
import { SharedModule } from "./shared.module";
import { DialogVerPeriodoContratoDetailDtoComponent } from "@views/periodos-contrato/dialog-ver-periodo-contrato-detail-dto/dialog-ver-periodo-contrato-detail-dto.component";
import { DialogUpdatePeriodoContratoComponent } from "@views/periodos-contrato/dialog-update-periodo-contrato/dialog-update-periodo-contrato.component";
import { ReporteDeudaPeriodoContratoComponent } from "@views/periodos-contrato/reporte-deuda-periodo-contrato/reporte-deuda-periodo-contrato.component";
import { ChartsModule } from "ng2-charts";
import { PropietariosModule } from "./propietarios.module";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ChartsModule,
    PropietariosModule
  ],
  declarations: [
    PeriodoContratoComponent,
    DialogVerPeriodoContratoDetailDtoComponent,
    DialogUpdatePeriodoContratoComponent,
    ReporteDeudaPeriodoContratoComponent
  ],
  exports: [
    PeriodoContratoComponent,
    DialogVerPeriodoContratoDetailDtoComponent,
    DialogUpdatePeriodoContratoComponent,
    ReporteDeudaPeriodoContratoComponent
  ],
  providers: [
  ],
})

export class PeriodosContratoModule { }
